import Nullstack from 'nullstack';
export default function IconDeviceWatchStats2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-device-watch-stats-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "6",
    y: "6",
    width: "12",
    height: "12",
    rx: "3"
  }), "   ", Nullstack.element("path", {
    d: "M9 18v3h6v-3"
  }), "   ", Nullstack.element("path", {
    d: "M9 6v-3h6v3"
  }), "   ", Nullstack.element("path", {
    d: "M12 10a2 2 0 1 0 2 2"
  }), " ");
}